import{jsx as r}from"react/jsx-runtime";import{useMenuContext as o}from"../../hooks/index.js";const u=()=>{const{MenuContentAsync:n,MenuContent:t,isContentLoaded:e}=o();return!e&&n?null:n?r(n,{}):t||null};export{u as MenuContentWrapper};
